module.exports = __webpack_public_path__ + "static/language-selector-mobile-screen@2x-d3d91baa5323831026f066b571a9eb80.png";